// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"5762c404","453":"0642f8c0"}[chunkId] + ".chunk.js";
};